<script setup lang="ts">
import { computed } from 'vue'
import { useManagementStore } from '@/store/management'
import { useSuccessStore } from '@/store/success'

// Configurações gerais do módulo gerencial (por empresa).
const store = useManagementStore()

const showFavorite = computed(() => store.showFavoriteOverview)

async function toggleFavoriteOverview(event: Event) {
  const checked = (event.target as HTMLInputElement).checked
  const ok = await store.updateModuleSettings({ show_favorite_overview: checked })
  if (ok) useSuccessStore().setSuccess(['Configurações do módulo salvas.'])
}
</script>

<template>
  <div class="bg-white shadow-4">
    <div class="border-b-2 border-stroke px-6 py-4">
      <h2 class="font-satoshi text-base font-bold text-black">Configurações do módulo</h2>
      <p class="mt-1 text-sm text-slate-500">Ajustes gerais de exibição do painel gerencial desta empresa.</p>
    </div>

    <div class="p-4 xl:p-6">
      <label class="flex items-start justify-between gap-4 border border-stroke px-4 py-3">
        <span>
          <span class="block text-sm font-medium text-slate-700">Exibir resumo da área favorita no Painel</span>
          <span class="mt-0.5 block text-xs text-slate-500">
            Mostra o cartão de destaque da área favorita no topo do Painel. Desmarque para empresas que não usam.
          </span>
        </span>
        <input
          type="checkbox"
          class="mt-1 h-5 w-5 accent-primary"
          :checked="showFavorite"
          @change="toggleFavoriteOverview" />
      </label>
    </div>
  </div>
</template>
